import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";

import Headline from "../../Headline/Headline";

import Historic from "./Application/Historic";
import Deployment from "./Application/Deployment";
import Information from "./Application/Information";
import Identification from "./Application/Identification";
import Model from "./Application/Model";
import OAuth from "./Application/OAuth";
import Admin from "./Application/Admin";
import AndroidPns from "./Application/AndroidPns";
import IosPns from "./Application/IosPns";
import IosPnsV2 from "./Application/IosPnsV2";
import ChangeOwner from "./Application/ChangeOwner";
import Sso from "./Application/Sso";

import Button from "../../UI/Button/Button";
import BadgeFolded from "../../UI/Badge/BadgeFolded";
import CardSticky from "../../UI/Card/CardSticky"

import * as ContactUtils from "../../Utils/ContactUtils";
import * as ApplicationsUtils from "../../Utils/ApplicationsUtils";

import { faBackward } from "@fortawesome/free-solid-svg-icons";
import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "APPLICATION_EDIT";

const ApplicationEdit = (props) => {

    const intl = useIntl();
    const [application, setApplication] = useState(null);
    const [isSandBoxApplication, setIsSandBoxApplication] = useState(false);

    //redux
    const applications = useSelector(state => isSandBoxApplication ? state.sandBoxApplications.applications : state.applications.applications);
    const user = useSelector(state => isSandBoxApplication ? state.sandBoxContacts.user : state.contacts.user);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect didmount");
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect location");
        if (ApplicationsUtils.isApplicationEditPath(props.location)) {
            if (ApplicationsUtils.isSandBoxApplication(props.location)) {
                setIsSandBoxApplication(true);
            }
        }
    }, [props.location]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect applications");
        const appId = ApplicationsUtils.getApplicationIdFromLocation(props.location);
        const application = ApplicationsUtils.getApplicationById(appId, applications);
        setApplication(application);
    }, [applications]);

    const handleBack = () => {
        LogService.trace(LOG_TAG, "handleBack");
        props.history.goBack();
    }

    LogService.trace(LOG_TAG, "render");
    const title = intl.messages.applicationEditionTitle;
    const subtitle = intl.messages.applicationEditionSubTitle;

    let isSuperAdmin = ContactUtils.isSuperAdminOrAppSuperAdmin(user);
    let isUpdatable = ApplicationsUtils.isMyApplication(application, user) || isSuperAdmin;

    let display = null;
    if (application) {
        display =
            <div>
                <Headline
                    title={title}
                    subtitle={subtitle} /* Manage your application Sandbox ? */
                />

                <CardSticky>
                    {isSandBoxApplication && <BadgeFolded label="SANDBOX" className="bg-green badge-sm" />}
                    <Button
                        id="backButton"
                        label={isSandBoxApplication ? intl.messages.sandBoxApplicationEditionBackButton : intl.messages.applicationEditionBackButton}
                        icon={faBackward}
                        className="btn-primary"
                        onClick={handleBack}
                    />
                </CardSticky>

                <div className="row">
                    <div className="col-xxl-9 col-lg-8">
                        <Information
                            applicationId={application.id}
                            isUpdateEnabled={isUpdatable}
                            isSandBoxApplication={isSandBoxApplication}
                        />
                        <Identification
                            applicationId={application.id}
                            isUpdateEnabled={isUpdatable}
                            isSandBoxApplication={isSandBoxApplication}
                        />
                        <OAuth
                            applicationId={application.id}
                            isUpdateEnabled={isUpdatable}
                            isSandBoxApplication={isSandBoxApplication}
                        />
                        <AndroidPns
                            applicationId={application.id}
                            isUpdateEnabled={isUpdatable}
                            isSandBoxApplication={isSandBoxApplication}
                        />
                        <IosPnsV2
                            applicationId={application.id}
                            isUpdateEnabled={isUpdatable}
                            isSandBoxApplication={isSandBoxApplication}
                        />
                        <IosPns
                            applicationId={application.id}
                            isUpdateEnabled={isUpdatable}
                            isSandBoxApplication={isSandBoxApplication}
                        />
                    </div>

                    <div className="col-xxl-3 col-lg-4">
                        <Historic
                            applicationId={application.id}
                            isUpdateEnabled={isUpdatable}
                            isSandBoxApplication={isSandBoxApplication}
                        />
                        <ChangeOwner
                            applicationId={application.id}
                            isUpdateEnabled={isUpdatable}
                            isSandBoxApplication={isSandBoxApplication}
                        />
                        <Deployment
                            applicationId={application.id}
                            isUpdateEnabled={isUpdatable && !isSandBoxApplication}
                            isSandBoxApplication={isSandBoxApplication}
                        />
                        <Model
                            applicationId={application.id}
                            isUpdateEnabled={isUpdatable && !isSandBoxApplication}
                            isSandBoxApplication={isSandBoxApplication}
                        />
                        {isSuperAdmin &&
                            <Admin
                                applicationId={application.id}
                                isUpdateEnabled={isUpdatable}
                                isSandBoxApplication={isSandBoxApplication}
                            />
                        }
                        <Sso
                            applicationId={application.id}
                            isUpdateEnabled={isUpdatable}
                            isSandBoxApplication={isSandBoxApplication}
                        />
                    </div>
                </div>
            </div>
    }
    return display;
}

ApplicationEdit.defaultProps = {
}

ApplicationEdit.propTypes = {
};

export default withRouter(ApplicationEdit);
